import { render, staticRenderFns } from "./poform.vue?vue&type=template&id=0db0f2ee"
import script from "./poform.vue?vue&type=script&lang=js"
export * from "./poform.vue?vue&type=script&lang=js"
import style0 from "./poform.vue?vue&type=style&index=0&id=0db0f2ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports